import campaignsJson from '../../demo/fixtures/campaigns.json'
import chainStepsJson from '../../demo/fixtures/chain-steps.json'
import partnershipJson from '../../demo/fixtures/partnership.json'
import fixture from '../../demo/fixtures/renewal.json'
import { formatUsd } from '../../demo/format'

function fill(template: string, values: Record<string, string>): string {
  return Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`{${key}}`, value), template)
}

if (import.meta.env.DEV) {
  const mugCampaign = campaignsJson.campaigns.find((item) => item.id === fixture.task.campaignId)
  const fanProduct = campaignsJson.products.find((item) => item.id === fixture.proposal.addProducts[0]?.id)
  const fanCampaign = campaignsJson.campaigns.find((item) => item.productId === fanProduct?.id)
  if (fanCampaign?.budget.total !== fixture.proposal.upsell) throw new Error('Renewal upsell must match c-fan-us total budget')
  if (fanProduct?.name !== fixture.proposal.addProducts[0]?.name) throw new Error('Renewal product must match products fixture')
  if (mugCampaign?.metrics.roas !== fixture.basis.roas) throw new Error('Renewal ROAS must match c-mug-us metrics')
  if (fixture.basis.quotaUsedRatio !== partnershipJson.current.usedRatio) throw new Error('Renewal quota ratio must match partnership quota ratio')
  if (JSON.stringify(fixture.task) !== JSON.stringify(partnershipJson.task)) throw new Error('Renewal and partnership must identify the same task')
}

const product = fixture.task.productShortName
const quotaFrom = formatUsd(fixture.proposal.quotaFrom)
const quotaTo = formatUsd(fixture.proposal.quotaTo)

export const renewalData = {
  ...fixture,
  stepSubtitle: chainStepsJson.steps.find((step) => step.id === '08')?.pptName ?? '',
  rows: fixture.copy.rows.map((row) => ({ ...row, label: fill(row.label, { product }) })),
  quotaFrom,
  quotaTo,
  addedProduct: fixture.proposal.addProducts[0]?.name ?? '',
  resultLine: fill(fixture.copy.resultLine, {
    roas: fixture.basis.roas.toFixed(1),
    avg: fixture.basis.accountAvgRoas.toFixed(1),
  }),
  confirmToast: fill(fixture.copy.confirmToast, { date: fixture.copy.effectiveLabel, quotaTo }),
}
